import { FC } from 'react'
import tw from 'twin.macro'
import { Grid, SubHeader } from '../UI'
import Dropdown from '../Dropdown'
import FeatherIcon from '../FeatherIcon'
import { FeatherIconType } from '../../types/icon'

type Props = {
  steps: Array<{
    header: string
    copy: string
    icon: FeatherIconType
  }>
  gridCols?: 3 | 4
}

const HowItWorks: FC<Props> = ({ steps, gridCols = 3 }) => {
  return (
    <section tw="bg-gb-red pt-[40px] pb-[40px] lg:(pt-[80px] pb-[80px]) text-white font-domaine overflow-hidden relative">
      <Grid>
        {/* Steps - Desktop */}
        {steps && (
          <div
            css={[
              tw`hidden lg:(col-span-full gap-16 grid)`,
              gridCols === 3 && tw`px-16 grid-cols-3`,
              gridCols === 4 && tw`px-8 grid-cols-4`,
            ]}
          >
            {steps.map((el, index) => (
              <div key={index} tw="border-l pl-4">
                <FeatherIcon icon={el.icon} cssStyle={tw`w-8 mr-8 mb-4`} />
                <div>
                  <h4 css={[SubHeader, tw`mb-4`]}>{el.header}</h4>
                  <p>{el.copy}</p>
                </div>
              </div>
            ))}
          </div>
        )}
        {/* Steps as Dropdown - Mobile */}
        {steps && (
          <div tw="col-span-full lg:hidden">
            {steps.map((el, index) => (
              <Dropdown
                key={index}
                header={el.header}
                content={<p>{el.copy}</p>}
                icon={el.icon}
                indexString={`${index + 1 < 10 && '0'}${index + 1}`}
                topBorder={index > 0}
              />
            ))}
          </div>
        )}
      </Grid>
    </section>
  )
}

export default HowItWorks
